import { Handler } from "../store-types";
import { ChangeUserOptionsActionType, IUIState, UIActionTypes } from "./types";

const changeUserOptions: Handler<IUIState, ChangeUserOptionsActionType> = (
  state,
  { payload }
) => {
  const { userOptions } = state;

  return { ...state, userOptions: { ...userOptions, ...payload } };
};

export const handlersUI = {
  [UIActionTypes.CHANGE_USER_OPTIONS]: changeUserOptions,
};
